import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import StatsCounter from '../components/StatsCounter';
import TrustBadges from '../components/TrustBadges';
import FAQ from '../components/FAQ';
import WhatsAppButton from '../components/WhatsAppButton';
import LocationMap from '../components/LocationMap';
import SimpleGainCalculator from '../components/SimpleGainCalculator';
import RealisationsPortfolio from '../components/RealisationsPortfolio';
import PresentationSEO from '../components/PresentationSEO';
import ServicesSEO from '../components/ServicesSEO';
import SectionLocale from '../components/SectionLocale';
import WhyChooseUs from '../components/WhyChooseUs';
import FinalCTA from '../components/FinalCTA';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Check, Zap, Shield, TrendingUp, Phone, Mail, MapPin, Car, Calendar, Star, CheckCircle, AlertCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  // Appointment form state
  const [appointmentData, setAppointmentData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    time: '',
    message: ''
  });
  const [appointmentStatus, setAppointmentStatus] = useState({ type: '', message: '' });
  const [appointmentLoading, setAppointmentLoading] = useState(false);

  const handleVehicleChange = (field, value) => {
    // Removed - now handled by VehicleConfigurator component
  };

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault();
    setAppointmentLoading(true);
    setAppointmentStatus({ type: '', message: '' });

    try {
      await axios.post(`${API}/appointments`, appointmentData);
      setAppointmentStatus({ 
        type: 'success', 
        message: 'Votre demande de rendez-vous a été envoyée avec succès! Nous vous contacterons rapidement.' 
      });
      setAppointmentData({
        name: '',
        phone: '',
        email: '',
        service: '',
        date: '',
        time: '',
        message: ''
      });
    } catch (error) {
      setAppointmentStatus({ 
        type: 'error', 
        message: 'Erreur lors de l\'envoi. Veuillez réessayer ou nous appeler directement.' 
      });
    } finally {
      setAppointmentLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      <Navbar />
      
      {/* Portfolio Réalisations - NEW */}
      <RealisationsPortfolio />

      {/* Hero Section - SEO Optimized */}
      <section className="relative pt-32 pb-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-5xl mx-auto space-y-8">
            <div className="inline-block bg-red-600/10 backdrop-blur-sm px-6 py-3 rounded-full border border-red-600/30 mb-4">
              <span className="text-red-600 font-bold text-lg">📍 Creutzwald • Moselle</span>
            </div>
            
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black text-white leading-tight">
              Électricien Automobile & Spécialiste en Gestion Électronique à <span className="text-red-600">Creutzwald</span>
            </h1>
            
            <div className="flex flex-wrap justify-center gap-4 text-lg md:text-xl text-gray-300 font-semibold">
              <span className="bg-slate-800/50 px-4 py-2 rounded-lg">Diagnostic automobile</span>
              <span className="bg-slate-800/50 px-4 py-2 rounded-lg">Recherche de panne</span>
              <span className="bg-slate-800/50 px-4 py-2 rounded-lg">Électricité automobile</span>
              <span className="bg-slate-800/50 px-4 py-2 rounded-lg">Reprogrammation moteur</span>
            </div>
            
            <div className="flex flex-wrap gap-4 justify-center pt-4">
              <a 
                href="tel:0749995728"
                className="inline-flex items-center bg-red-600 hover:bg-red-700 text-white font-bold px-10 py-5 rounded-xl transition-all transform hover:scale-105 text-xl shadow-lg"
              >
                <Phone className="mr-3 h-6 w-6" />
                PRENDRE RENDEZ-VOUS
              </a>
            </div>
            
            <p className="text-gray-400 text-lg pt-4">
              📞 <a href="tel:0749995728" className="text-red-600 hover:text-red-500 font-bold">07 49 99 57 28</a> • 14 rue Saint-Malo, 57150 Creutzwald
            </p>
          </div>
        </div>
      </section>

      {/* Présentation SEO - NEW */}
      <PresentationSEO />

      {/* Services SEO - NEW */}
      <ServicesSEO />

      {/* Stats Counter */}
      <StatsCounter />

      {/* Why Choose Us - NEW */}
      <WhyChooseUs />

      {/* Trust Badges */}
      <TrustBadges />

      {/* Section Locale - NEW */}
      <SectionLocale />

      {/* Calculateur de Gains */}
      <SimpleGainCalculator />

      {/* Réalisations avant/après */}
      <section className="py-20 px-4 bg-slate-900/50" id="realisations">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Nos Réalisations</h2>
            <p className="text-gray-400 text-lg">Quelques exemples de reprogrammations réussies</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <CardTitle className="text-white">Audi A3 2.0 TDI</CardTitle>
                <CardDescription className="text-gray-400">Stage 1 - 2021</CardDescription>
              </CardHeader>
              <CardContent className="text-gray-300 space-y-2">
                <div className="flex justify-between">
                  <span>Puissance origine:</span>
                  <span className="text-white font-semibold">150 ch</span>
                </div>
                <div className="flex justify-between">
                  <span>Puissance optimisée:</span>
                  <span className="text-red-600 font-bold">195 ch</span>
                </div>
                <div className="flex justify-between">
                  <span>Couple origine:</span>
                  <span className="text-white font-semibold">340 Nm</span>
                </div>
                <div className="flex justify-between">
                  <span>Couple optimisé:</span>
                  <span className="text-red-600 font-bold">440 Nm</span>
                </div>
                <div className="pt-4">
                  <Badge className="bg-green-600 text-white">+30% puissance</Badge>
                  <Badge className="bg-green-600 text-white ml-2">+29% couple</Badge>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <CardTitle className="text-white">BMW 320d</CardTitle>
                <CardDescription className="text-gray-400">Stage 1 - 2020</CardDescription>
              </CardHeader>
              <CardContent className="text-gray-300 space-y-2">
                <div className="flex justify-between">
                  <span>Puissance origine:</span>
                  <span className="text-white font-semibold">190 ch</span>
                </div>
                <div className="flex justify-between">
                  <span>Puissance optimisée:</span>
                  <span className="text-red-600 font-bold">245 ch</span>
                </div>
                <div className="flex justify-between">
                  <span>Couple origine:</span>
                  <span className="text-white font-semibold">400 Nm</span>
                </div>
                <div className="flex justify-between">
                  <span>Couple optimisé:</span>
                  <span className="text-red-600 font-bold">500 Nm</span>
                </div>
                <div className="pt-4">
                  <Badge className="bg-green-600 text-white">+29% puissance</Badge>
                  <Badge className="bg-green-600 text-white ml-2">+25% couple</Badge>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <CardTitle className="text-white">Mercedes C220d</CardTitle>
                <CardDescription className="text-gray-400">Stage 1 - 2022</CardDescription>
              </CardHeader>
              <CardContent className="text-gray-300 space-y-2">
                <div className="flex justify-between">
                  <span>Puissance origine:</span>
                  <span className="text-white font-semibold">194 ch</span>
                </div>
                <div className="flex justify-between">
                  <span>Puissance optimisée:</span>
                  <span className="text-red-600 font-bold">250 ch</span>
                </div>
                <div className="flex justify-between">
                  <span>Couple origine:</span>
                  <span className="text-white font-semibold">400 Nm</span>
                </div>
                <div className="flex justify-between">
                  <span>Couple optimisé:</span>
                  <span className="text-red-600 font-bold">520 Nm</span>
                </div>
                <div className="pt-4">
                  <Badge className="bg-green-600 text-white">+29% puissance</Badge>
                  <Badge className="bg-green-600 text-white ml-2">+30% couple</Badge>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Avis Clients Section */}
      <section className="py-20 px-4" id="avis">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Avis Clients</h2>
            <p className="text-gray-400 text-lg">Ce que nos clients disent de nous</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <div className="flex items-center space-x-2 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="h-5 w-5 fill-yellow-500 text-yellow-500" />
                  ))}
                </div>
                <CardTitle className="text-white">Excellent travail!</CardTitle>
                <CardDescription className="text-gray-400">Marc D. - Audi A4</CardDescription>
              </CardHeader>
              <CardContent className="text-gray-300">
                <p>"Reprogrammation Stage 1 sur mon A4 2.0 TDI. Résultat bluffant! +50ch et -1L/100km. Service professionnel et rapide. Je recommande vivement!"</p>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <div className="flex items-center space-x-2 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="h-5 w-5 fill-yellow-500 text-yellow-500" />
                  ))}
                </div>
                <CardTitle className="text-white">Très satisfait</CardTitle>
                <CardDescription className="text-gray-400">Sophie L. - BMW 320d</CardDescription>
              </CardHeader>
              <CardContent className="text-gray-300">
                <p>"Conversion E85 + reprog. Économies immédiates et performances au top! L'équipe est compétente et à l'écoute. Travail soigné."</p>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <div className="flex items-center space-x-2 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="h-5 w-5 fill-yellow-500 text-yellow-500" />
                  ))}
                </div>
                <CardTitle className="text-white">Professionnel</CardTitle>
                <CardDescription className="text-gray-400">Thomas R. - Mercedes C220</CardDescription>
              </CardHeader>
              <CardContent className="text-gray-300">
                <p>"Suppression FAP + Stage 1. Fini les problèmes de régénération! La voiture respire enfin. Tarif correct et garantie rassurante."</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section className="py-20 px-4 bg-slate-900/50" id="tarifs">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Nos Prestations</h2>
            <p className="text-gray-400 text-lg">Stage 1, 2, 3 et Conversion E85</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <Badge className="bg-blue-600 text-white w-fit mb-2">Le plus populaire</Badge>
                <CardTitle className="text-white text-2xl">Stage 1</CardTitle>
                <CardDescription className="text-gray-400">Optimisation logicielle</CardDescription>
                <p className="text-4xl font-bold text-white mt-4">299€</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Gain de puissance +20 à +40%</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Amélioration accélérations</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Réduction consommation possible</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Retour à l'origine offert</span>
                  </li>
                </ul>
                <Button className="w-full mt-6 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <Badge className="bg-purple-600 text-white w-fit mb-2">Performance</Badge>
                <CardTitle className="text-white text-2xl">Stage 2</CardTitle>
                <CardDescription className="text-gray-400">Optimisation + mécanique</CardDescription>
                <p className="text-4xl font-bold text-white mt-4">Sur devis</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Gains +40 à +60%</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Ligne d'échappement sport</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Échangeur air/air amélioré</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Test sur route après intervention</span>
                  </li>
                </ul>
                <Button className="w-full mt-6 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700">
              <CardHeader>
                <Badge className="bg-orange-600 text-white w-fit mb-2">Extrême</Badge>
                <CardTitle className="text-white text-2xl">Stage 3</CardTitle>
                <CardDescription className="text-gray-400">Préparation complète</CardDescription>
                <p className="text-4xl font-bold text-white mt-4">Sur devis</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Gains +60% et plus</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Turbo / compresseur plus gros</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Injecteurs haute performance</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-5 w-5 text-red-600 mr-2 mt-0.5" />
                    <span>Cartographie sur-mesure</span>
                  </li>
                </ul>
                <Button className="w-full mt-6 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>
          </div>

          {/* Solutions Anti-Pollution */}
          <div className="text-center mb-12 mt-20">
            <h3 className="text-3xl font-bold text-white mb-4">Solutions Anti-Pollution</h3>
            <p className="text-gray-400">Solutions professionnelles pour les systèmes anti-pollution</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="bg-slate-800/50 border-slate-700 hover:border-red-600 transition-all">
              <CardHeader>
                <CardTitle className="text-white text-xl">Solution FAP</CardTitle>
                <CardDescription className="text-gray-400">Filtre à particules</CardDescription>
                <p className="text-3xl font-bold text-white mt-4">À partir de 150€</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300 text-sm">
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Désactivation complète</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Fin des régénérations</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Performance restaurée</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Compatible Stage 1</span>
                  </li>
                </ul>
                <Button className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700 hover:border-red-600 transition-all">
              <CardHeader>
                <CardTitle className="text-white text-xl">Solution EGR</CardTitle>
                <CardDescription className="text-gray-400">Vanne EGR</CardDescription>
                <p className="text-3xl font-bold text-white mt-4">À partir de 150€</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300 text-sm">
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Désactivation vanne EGR</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Obturateur mécanique</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Ralenti stabilisé</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Moins d'encrassement</span>
                  </li>
                </ul>
                <Button className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700 hover:border-red-600 transition-all">
              <CardHeader>
                <CardTitle className="text-white text-xl">Solution AdBlue</CardTitle>
                <CardDescription className="text-gray-400">Système AdBlue/SCR</CardDescription>
                <p className="text-3xl font-bold text-white mt-4">À partir de 399€</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300 text-sm">
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Désactivation électronique</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Aucun voyant tableau</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Plus de défaut AdBlue</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Intervention invisible</span>
                  </li>
                </ul>
                <Button className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>

            <Card className="bg-slate-800/50 border-slate-700 hover:border-red-600 transition-all">
              <CardHeader>
                <CardTitle className="text-white text-xl">Solution DTC</CardTitle>
                <CardDescription className="text-gray-400">Codes défauts</CardDescription>
                <p className="text-3xl font-bold text-white mt-4">À partir de 100€</p>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-gray-300 text-sm">
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Suppression codes erreur</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Voyants éteints</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Diagnostic inclus</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="h-4 w-4 text-red-600 mr-2 mt-0.5" />
                    <span>Solution permanente</span>
                  </li>
                </ul>
                <Button className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white">
                  Demander un devis
                </Button>
              </CardContent>
            </Card>
          </div>

          <div className="mt-12 p-6 bg-slate-800/30 border border-slate-700 rounded-lg">
            <div className="flex items-start space-x-4">
              <AlertCircle className="h-6 w-6 text-yellow-500 flex-shrink-0 mt-0.5" />
              <div className="text-gray-300 text-sm">
                <p className="font-semibold text-white mb-2">⚠️ Informations importantes</p>
                <p>Ces interventions sont destinées aux véhicules de compétition, export, usage privé sur terrain clos ou collection, ou aux applications industrielles (machines, engins, etc.).</p>
                <p className="mt-2">🚫 La suppression de dispositifs antipollution n'est pas autorisée pour un usage routier en France conformément à la réglementation en vigueur.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Appointment Section */}
      <section className="py-20 px-4" id="rdv">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">Prendre Rendez-vous</h2>
            <p className="text-gray-400 text-lg">Réservez votre créneau pour une reprogrammation</p>
          </div>

          <Card className="bg-slate-800/50 border-slate-700">
            <CardContent className="pt-6">
              {appointmentStatus.message && (
                <Alert 
                  className={`mb-6 ${
                    appointmentStatus.type === 'success' 
                      ? 'bg-green-900/20 border-green-700' 
                      : 'bg-red-900/20 border-red-700'
                  }`}
                >
                  {appointmentStatus.type === 'success' ? (
                    <CheckCircle className="h-4 w-4 text-green-500" />
                  ) : (
                    <AlertCircle className="h-4 w-4 text-red-500" />
                  )}
                  <AlertDescription className="text-white">
                    {appointmentStatus.message}
                  </AlertDescription>
                </Alert>
              )}

              <form onSubmit={handleAppointmentSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">Nom complet *</Label>
                    <Input
                      required
                      value={appointmentData.name}
                      onChange={(e) => setAppointmentData({...appointmentData, name: e.target.value})}
                      className="bg-slate-700 border-slate-600 text-white"
                      placeholder="Jean Dupont"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">Téléphone *</Label>
                    <Input
                      required
                      type="tel"
                      value={appointmentData.phone}
                      onChange={(e) => setAppointmentData({...appointmentData, phone: e.target.value})}
                      className="bg-slate-700 border-slate-600 text-white"
                      placeholder="06 12 34 56 78"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <Label className="text-white">Email *</Label>
                  <Input
                    required
                    type="email"
                    value={appointmentData.email}
                    onChange={(e) => setAppointmentData({...appointmentData, email: e.target.value})}
                    className="bg-slate-700 border-slate-600 text-white"
                    placeholder="jean.dupont@email.fr"
                  />
                </div>

                <div className="space-y-2">
                  <Label className="text-white">Service souhaité *</Label>
                  <Select 
                    required
                    onValueChange={(value) => setAppointmentData({...appointmentData, service: value})}
                  >
                    <SelectTrigger className="bg-slate-700 border-slate-600 text-white">
                      <SelectValue placeholder="Choisissez un service" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="stage1">Reprogrammation Stage 1</SelectItem>
                      <SelectItem value="stage2">Reprogrammation Stage 2</SelectItem>
                      <SelectItem value="stage3">Reprogrammation Stage 3</SelectItem>
                      <SelectItem value="e85">Conversion E85</SelectItem>
                      <SelectItem value="fap">Suppression FAP/EGR</SelectItem>
                      <SelectItem value="autre">Autre</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">Date souhaitée *</Label>
                    <Input
                      required
                      type="date"
                      value={appointmentData.date}
                      onChange={(e) => setAppointmentData({...appointmentData, date: e.target.value})}
                      className="bg-slate-700 border-slate-600 text-white"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">Heure souhaitée *</Label>
                    <Input
                      required
                      type="time"
                      value={appointmentData.time}
                      onChange={(e) => setAppointmentData({...appointmentData, time: e.target.value})}
                      className="bg-slate-700 border-slate-600 text-white"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <Label className="text-white">Message (optionnel)</Label>
                  <Textarea
                    value={appointmentData.message}
                    onChange={(e) => setAppointmentData({...appointmentData, message: e.target.value})}
                    className="bg-slate-700 border-slate-600 text-white min-h-[120px]"
                    placeholder="Informations supplémentaires sur votre véhicule ou vos besoins..."
                  />
                </div>

                <Button 
                  type="submit"
                  disabled={appointmentLoading}
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-6 text-lg"
                >
                  <Calendar className="mr-2 h-5 w-5" />
                  {appointmentLoading ? 'Envoi en cours...' : 'Réserver mon rendez-vous'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-4" id="contact">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-8">Nous Contacter</h2>
          <p className="text-gray-400 text-lg mb-12">Une question ? N'hésitez pas à nous appeler</p>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Card className="bg-slate-800/50 border-slate-700">
              <CardContent className="pt-6 text-center">
                <Phone className="h-8 w-8 text-red-600 mx-auto mb-3" />
                <p className="text-white font-semibold mb-2">Téléphone</p>
                <a href="tel:0749995728" className="text-gray-400 hover:text-red-600">07 49 99 57 28</a>
              </CardContent>
            </Card>
            
            <Card className="bg-slate-800/50 border-slate-700">
              <CardContent className="pt-6 text-center">
                <Mail className="h-8 w-8 text-red-600 mx-auto mb-3" />
                <p className="text-white font-semibold mb-2">Email</p>
                <a href="mailto:Jc.performance57@outlook.fr" className="text-gray-400 hover:text-red-600 text-sm">
                  Jc.performance57@outlook.fr
                </a>
              </CardContent>
            </Card>
            
            <Card className="bg-slate-800/50 border-slate-700">
              <CardContent className="pt-6 text-center">
                <MapPin className="h-8 w-8 text-red-600 mx-auto mb-3" />
                <p className="text-white font-semibold mb-2">Adresse</p>
                <p className="text-gray-400 text-sm">14 rue saint Malo<br />57150 Creutzwald</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* FAQ Section - NEW */}
      <FAQ />

      {/* Location Map */}
      <LocationMap />

      {/* Final CTA - NEW */}
      <FinalCTA />

      {/* WhatsApp Button */}
      <WhatsAppButton />

      <Footer />
    </div>
  );
};

export default HomePage;
